<div class="">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">ثبت نام تانکر</h2>
      </div>

      <div class="modal-body">
        <h2>اطلاعات خود را وارد کنید</h2>

        <form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submit()">
          <!-- phoneNumber field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('strMobile').value ? 'direction-ltr' : ''"
          >
            <span class="form-control-icon">
              <mat-icon>phone_iphone</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="strMobile"
              inputmode="numeric"
              appNumericOnly
              placeholder="* شماره موبایل"
            />
          </div>

          <!-- name field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>account_circle</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="strName"
              placeholder="* نام"
              autofocus
            />
          </div>

          <!-- family field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>account_circle</mat-icon>
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="strFamily"
              placeholder="* نام خانوادگی"
            />
          </div>

          <!-- nationalId field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('strID').value ? 'direction-ltr' : ''"
          >
            <span class="form-control-icon">
              <mat-icon>badge</mat-icon>
            </span>
            <input
              class="form-control"
              formControlName="strID"
              inputmode="numeric"
              appNumericOnly
              placeholder="* کد ملی مالک خودرو"
            />
          </div>

          <!-- strTel field -->
          <div
            class="form-group has-icon"
            [ngClass]="formGroup.get('strTel').value ? 'direction-ltr' : ''"
          >
            <span class="form-control-icon">
              <mat-icon>fax</mat-icon>
            </span>
            <input
              class="form-control"
              formControlName="strTel"
              inputmode="numeric"
              maxlength="11"
              appNumericOnly
              placeholder="* تلفن ثابت"
            />
          </div>

          <!-- استان/شهر -->

          <div class="w-100 h-100">
            <div class="row gx-2 gy-0">
              <div class="col-6">
                <!-- state field -->
                <div class="form-group has-icon">
                  <span class="form-control-icon">
                    <mat-icon>apartment</mat-icon>
                  </span>
                  <select (change)="getCities($event)">
                    <option [value]="null" disabled selected>* استان</option>
                    <option
                      *ngFor="let state of states$ | async"
                      [value]="state.strState"
                    >
                      {{ state.strStateName }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-6">
                <!-- city field -->
                <div class="form-group has-icon">
                  <span class="form-control-icon">
                    <mat-icon>apartment</mat-icon>
                  </span>
                  <select formControlName="strCity">
                    <option [value]="null" disabled selected>* شهر</option>
                    <option
                      *ngFor="let city of cities$ | async"
                      [value]="city.strCity"
                    >
                      {{ city.strCityName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- map picker field-->
          <div class="form-group has-icon map-field-wrapper">
            <span class="form-control-icon">
              <mat-icon>add_location_alt</mat-icon>
            </span>

            <input
              class="form-control"
              formControlName="strAddress"
              [placeholder]="
                showMap ? '* آدرس محل نصب' : 'آدرس محل نصب (اختیاری)'
              "
            />

            <button
              type="button"
              class="btn btn-warning show-map-btn"
              (click)="show_Map()"
            >
              <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
            </button>

            <custom-map
              *ngIf="showMapDialog"
              [longLat]="[coordinates.fLon, coordinates.fLat]"
              [isOpenModal]="true"
              (mdl_Submit)="submitMap($event)"
            ></custom-map>
          </div>

          <!-- carType field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>fire_truck</mat-icon>
            </span>
            <select formControlName="tiGPSType">
              <option [value]="null" disabled selected>* نوع تانکر</option>
              <option
                *ngFor="let carType of carTypes$ | async"
                [value]="carType.tiGPSType"
              >
                {{ carType.strComment }}
              </option>
            </select>
          </div>

          <!-- vehicleNumber field -->
          <div class="vehicle-no-field-wrapper">
            <!-- <label for="strVehicleNo">پلاک تانکر</label> -->
            <div class="vehicle-no-field" id="strVehicleNo">
              <input
                type="text"
                maxlength="2"
                inputmode="numeric"
                class="border-left"
                formControlName="plak4"
                placeholder="- -"
                (keydown)="onlyNumber($event)"
              />
              <input
                type="text"
                maxlength="3"
                inputmode="numeric"
                formControlName="plak3"
                placeholder="- - -"
                (keydown)="onlyNumber($event)"
              />
              <input
                type="text"
                maxlength="1"
                formControlName="plak2"
                placeholder="-"
                (keydown)="onlyPersian($event)"
                (input)="sanitizePersian($event)"
              />
              <input
                type="text"
                maxlength="2"
                inputmode="numeric"
                formControlName="plak1"
                placeholder="- -"
                (keydown)="onlyNumber($event)"
              />
              <span><img src="./assets/imgs/iran-flag-dark.svg" /></span>
            </div>
          </div>

          <!-- تصویر مجوز صادره از طرف شرکت آب و فاضلاب  -->

          <div class="form-group position-relative mb-3">
            <p class="my-2">
              تصویر مجوز صادره از طرف شرکت آب و فاضلاب را آپلود کنید.
            </p>

            <file-uploader
              [maxFileSize]="3"
              (submit)="onFileSubmit($event)"
            ></file-uploader>
          </div>

          <!-- description field -->
          <div class="form-group has-icon">
            <span class="form-control-icon">
              <mat-icon>description</mat-icon>
            </span>
            <textarea
              class="form-control"
              formControlName="strComment"
              placeholder="توضیحات"
            ></textarea>
          </div>
        </form>
      </div>

      <div class="modal-footer d-flex flex-row-reverse justify-content-end">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="
            formGroup.invalid || formGroup.pristine || isSubmitDisabled
          "
          (click)="form.ngSubmit.emit()"
        >
          ثبت نام
        </button>
      </div>
    </div>
  </div>
</div>
